import { RestSchemas } from '@/contexts/QueryProvider'
import { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'
import { TruncateExpand } from './TruncateExpand'

type MessagesDagsterMessageEvent = RestSchemas['Messages.Dagster.MessageEvent']

export const logsTableColumns: ColumnDef<MessagesDagsterMessageEvent>[] = [
  {
    id: 'timestamp',
    accessorFn: (row) => row.timestamp,
    header: 'Timestamp',
    cell: ({ cell }) => format(Number(cell.getValue()), 'PPpp') ?? ('-' as string),
    enableGlobalFilter: true,
  },
  {
    id: 'stepKey',
    accessorFn: (row) => row.stepKey,
    header: 'Step key',
    cell: ({ cell }) => cell.getValue() ?? ('-' as string),
  },
  {
    id: 'eventType',
    accessorFn: (row) => row.eventType,
    header: 'Event type',
    cell: ({ cell }) => cell.getValue() ?? ('-' as string),
  },
  {
    id: 'message',
    accessorFn: (row) => row.message,
    header: 'Message',
    cell: ({ cell }) => <TruncateExpand text={(cell.getValue() ?? '-') as string} />,
  },
]
